import React from "react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { TrashIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { InvoiceListItemProps } from "./invoice-list-item.types"
import { Logo } from "@/components/ui/logo";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import dayjs from "dayjs"
import { InvoiceExtended } from "@/types"
import { EllipsisVertical } from "lucide-react";
import { InvoicePreview } from "./components/invoice-preview";

import './invoice-list-item.style.scss';


const InvoiceListItem: React.FC<InvoiceListItemProps> = ({invoice}) => {

  const { id, seller, currency, totalAmount, issueDate, paymentDueDate } = invoice as InvoiceExtended;

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency == 'Ft' ? 'HUF' : currency,
  })

  const onDetach = (_id: string) => {
    console.log('Detach invoice', invoice)
  }

  return (
    <Card key={`invoice-${invoice?.id}`} className={`w-full`}>
        <CardHeader className="py-0 px-0">
            <CardTitle className="flex items-center gap-2 text-base border-b border-foreground/10 pl-4">
                <InvoicePreview invoice={invoice} />
                <div className="ml-auto">
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon">
                            <EllipsisVertical className="h-4 w-4" />
                        </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                        <DropdownMenuItem onClick={() => onDetach && onDetach(id)}>
                            <TrashIcon className="h-4 w-4 mr-2" />
                            Detach Invoice
                        </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            </CardTitle>
        </CardHeader>
        <CardContent className="py-0 pb-3 px-3 flex flex-row gap-2 mt-4">
            {seller && <Logo url={seller.corporateWebsiteURL} shortName={seller.shortCompanyName} longName={seller.companyName} />}
            <div className="flex flex-col gap-1 mr-0 text-left">
                <p className="text-md mr-0 text-left font-semibold">{seller.shortCompanyName || seller.companyName || 'N/A'}</p>
                <span className="text-xs mr-0 text-left text-foreground/50">
                    <span>{dayjs(issueDate).format('MMM DD')}</span> - <span>{dayjs(paymentDueDate).format('MMM DD')}</span>
                </span>
            </div>
            <p className="ml-auto text-md font-semibold">
                {currencyFormatter.format(totalAmount)}
            </p>
        </CardContent>
    </Card>
  )
}
export { InvoiceListItem }
